import { REMOVE_OBJECT_LINKS_FROM_STATE } from './objectLinkTypes';

export default function removeObjectLinks(objectId: string) {
  return {
    type: REMOVE_OBJECT_LINKS_FROM_STATE,
    objectId,
  };
}
